import { Draggable } from "react-beautiful-dnd";
import { Text } from "@mantine/core";
import PropTypes from "prop-types";
import {
  IconChevronDown,
  IconChevronUp,
  IconGripHorizontal,
} from "@tabler/icons-react";
import { StyledButton, StyledEditButton, StyledTR } from "./DndList.styles";

const DndList = ({
  type,
  items,
  handleUp,
  handleDown,
  handleNavigation,
  handleModal,
}) => {
  return items.map((item, index) => (
    <Draggable key={item.Id} index={index} draggableId={item.Id.toString()}>
      {(provided) => (
        <StyledTR ref={provided.innerRef} {...provided.draggableProps}>
          <td className="table-id text-center border-none" width={150}>
            <Text>{item.DisplayOrder}</Text>
          </td>
          <td className="table-name border-none" width={450}>
            <Text color="dimmed" size="sm">
              {item.Name}
            </Text>
          </td>
          <td className="border-none" width={500}>
            <span className="table-buttons">
              {type === "KOOCLASS" && (
                <StyledEditButton onClick={() => handleNavigation(item)}>
                  Edit Lesson
                </StyledEditButton>
              )}
              {type === "KOOCLASSTOPIC" && (
                <StyledEditButton onClick={() => handleModal(item)}>
                  Move
                </StyledEditButton>
              )}
              <StyledButton onClick={() => handleUp(index)}>
                <IconChevronUp size="1.05rem" />
              </StyledButton>
              <StyledButton onClick={() => handleDown(index)}>
                <IconChevronDown size="1.05rem" />
              </StyledButton>
              <StyledButton {...provided.dragHandleProps}>
                <IconGripHorizontal color="white" size="1.05rem" stroke={1.5} />
              </StyledButton>
            </span>
          </td>
        </StyledTR>
      )}
    </Draggable>
  ));
};

DndList.propTypes = {
  type: PropTypes.string.isRequired, // KOOCLASS or KOOCLASSTOPIC
  items: PropTypes.array.isRequired,
  handleUp: PropTypes.func,
  handleDown: PropTypes.func,
  handleNavigation: PropTypes.func,
  handleModal: PropTypes.func,
};

export default DndList;
